export default function generateNonce() {
  const now_ms = Date.now()
  const random_suffix = Math.round(Math.random() * 999)

  return Number(String(now_ms) + String(random_suffix))
}
